import React from "react";

const TextField = ({
  id,
  label,
  labelClassName,
  inputClassName,
  placeholder,
  onChange,
  value,
  onFocusEffect,
  onFocusEffectColor,
  onClick,
  onMouseOver,
  type,
  maxLength,
  autoComplete,
  name,
  spellCheck,
  className,
  notEditableValue,
  min,
  defaultValue,
  accept,
  isRequired
}) => {
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className={`ms-1 text-black pb-2 w-full ${labelClassName}`}>
          {label}{isRequired && (<span className="text-danger">*</span>)}
        </label>
      )}
      <input
        id={id}
        className={inputClassName}
        placeholder={placeholder}
        defaultValue={defaultValue}
        type={type ? type : "text"}
        onChange={onChange}
        onClick={onClick}
        onMouseOver={onMouseOver}
        maxLength={maxLength ? maxLength : null}
        autoComplete={autoComplete}
        value={value}
        name={name}
        spellCheck={spellCheck}
        min={min}
        accept={accept}
      />
    </div>
  );
};

export default TextField;